import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import '../../images/figure/index.esm.js';
import { EGDSImage } from '../../images/image/index.esm.js';
import 'react';
import '../../images/utils/image-queue/index.esm.js';
import '../../images/image-link/index.esm.js';
import '../../images/types/index.esm.js';
import '../../utils/index_orig/index.esm.js';
import '../../utils/theme/theme-provider/index.esm.js';
import '../video-basic/index.esm.js';
import '../video-embed/index.esm.js';
import { PlayerState } from '../types/index.esm.js';
import { youTubeThumbnailImage } from '../video-helper/index.esm.js';
import { EGDSVideoLayerControls } from '../video-layer-controls/index.esm.js';
import { EGDSVideoLayerLoading } from '../video-layer-loading/index.esm.js';
import styles from '../../styles/uitk-egds-video.css';
import { classNames } from '../../utils/classnames/index.esm.js';
const getClassNameList = classNames.bind(styles);
const playerStateImageVisible = [PlayerState.ENDED, PlayerState.UNSTARTED, PlayerState.CUED];
const EGDSVideoLayer = ({
  alt,
  controls,
  isPlayerReady,
  playerError,
  playerState,
  src,
  buttonText
}) => {
  const coverSrc = youTubeThumbnailImage(src);
  const isPlaceholderImageVisibile = playerStateImageVisible.includes(playerState) && !playerError.status;
  return jsxs(Fragment, {
    children: [isPlaceholderImageVisibile && jsx(EGDSImage, {
      alt: alt,
      blankDefault: !coverSrc,
      src: coverSrc
    }), jsx(EGDSVideoLayerLoading, {
      className: getClassNameList({
        'is-hidden': isPlayerReady
      }),
      playerState: playerState
    }), jsx(EGDSVideoLayerControls, {
      className: getClassNameList({
        'is-hidden': !isPlayerReady || playerError.status,
        'uitk-image-placeholder uitk-image-placeholder-image': !coverSrc && ![PlayerState.PLAYING, PlayerState.PAUSED].includes(playerState)
      }),
      buttonText: buttonText,
      controls: controls,
      playerState: playerState
    })]
  });
};
export { EGDSVideoLayer };